import {Banner, Checkbox, DataTable, DatePicker, DescriptionList, Modal, TextStyle} from "@shopify/polaris";
import {Redirect} from "@shopify/app-bridge/actions";
import {useCallback, useState} from "react";
import Api from "../../helpers/api";
import {formatDate} from "../Dates";
import {useToast} from "@shopify/app-bridge-react";

export default ({
    active = false,
    onClose = () => {},
}) => {
    const [loading, setLoading] = useState(false);
    const [{month, year}, setDate] = useState({month: (new Date()).getMonth(), year: (new Date()).getFullYear()});
    const [selectedDates, setSelectedDates] = useState({
        start: new Date(),
        end: new Date(),
    });
    const [errors, setErrors] = useState({});

    const toast = useToast();
    const showToast = (message) => toast.show(message, {duration: 5000});

    const handleMonthChange = useCallback((month, year) => setDate({month, year}), []);

    const onInternalClose = useCallback(() => {
        if (loading) {
            return;
        }

        setSelectedDates({
            start: new Date(),
            end: new Date(),
        });
        onClose();
    }, [loading]);

    const onExport = useCallback(() => {
        setLoading(true);

        Api.exportShipping({
            date_start: formatDate(selectedDates.start),
            date_end: formatDate(selectedDates.end),
        })
            .then(() => {
                onInternalClose();
                showToast("Your export will be delivered by email to your email address. Depending on how many orders you’re exporting, this could take a few moments.");
            })
            .catch((error) => {
                if (error.response.status == 403) {
                    showToast("You don't have permissions to export orders");
                } else if (error.response.status == 404) {
                    showToast("Schedule not found");
                } else {
                    showToast("Server error, try again.");
                }
            })
            .finally(() => {
                setLoading(false);
                onInternalClose();
            });
    }, [selectedDates]);

    return (<Modal
        open={active}
        title={`Shipping Export`}
        onClose={onClose}
        primaryAction={{
            content: 'Export',
            onAction: onExport,
            loading: loading
        }}
        secondaryActions={[
            {
                content: "Close",
                onAction: onInternalClose,
                disabled: loading,
            }
        ]}
    >
        <Modal.Section>
            { (!!errors.date_start || !!errors.date_end) && (
                <Banner status={"critical"} onDismiss={() => setErrors({})}>
                    {!!errors.date_start && (errors.date_start)}
                    {!!errors.date_end && (errors.date_end)}
                </Banner>
            ) }

            <DatePicker
                month={month}
                year={year}
                onChange={setSelectedDates}
                onMonthChange={handleMonthChange}
                selected={selectedDates}
                multiMonth
                allowRange
            />
        </Modal.Section>
    </Modal>);
}
